import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-terms-and-conditions c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "p-terms-and-conditions__inner c-common-inner" }
const _hoisted_4 = { class: "p-terms-and-conditions__file" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheSimpleHeader = _resolveComponent("TheSimpleHeader")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheSimpleHeader),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CommonHeading, { class: "p-terms-and-conditions__heading" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Terms & Conditions ", -1)
          ])),
          _: 1,
          __: [0]
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("embed", { src: _ctx.terms }, null, 8, _hoisted_5)
        ])
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}